import * as movies from './api.movies';
import * as list from './api.list';
import * as users from './api.users';
import * as comments from './api.comments';
import * as notifications from './api.notifications';

export default {
  movies,
  list,
  users,
  comments,
  notifications,
};
